import { Box, Button, Typography } from '@mui/material';
import { black } from 'app/components/ThemeProvider/colors';
import {
  calculateBtn,
  currencyBox,
  currencyInfoBox,
  currencyInfoText,
  currencyText,
  expandBtn,
} from './CurrencyBox.sx';
import CalculatorIcon from 'app/components/Icons/CalculatorIcon';
import MinimizeIcon from 'app/components/Icons/MinimizeIcon';
import ExpandIcon from 'app/components/Icons/ExpandIcon';
import React, { Dispatch, SetStateAction } from 'react';
import { Currency } from 'app/constants/types';
import CalculatorModal from './CalculatorModal';
import { useTranslation } from 'react-i18next';

interface Props {
  expand: boolean;
  showCalculator: boolean;
  largeScreens: boolean;
  mediumScreens: boolean;
  smallScreens: boolean;
  handleExpand: () => void;
  setShowCalculator: Dispatch<SetStateAction<boolean>>;
  currency: Currency;
}
const CurrencyBox = (props: Props) => {
  const {
    expand,
    showCalculator,
    currency,
    largeScreens,
    mediumScreens,
    handleExpand,
    setShowCalculator,
    smallScreens,
  } = props;
  const { t } = useTranslation();

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: '30px' }}>
        <Typography sx={{ color: black, fontSize: '22px',fontWeight: 600 }}>{t('homePage.currency')}</Typography>
        <Box sx={{ display: 'flex', gap: '12px' }}>
          <Button
            color={'tertiary'}
            sx={expand || largeScreens ? calculateBtn : { ...calculateBtn, padding: '8px !important' }}
            onClick={() => setShowCalculator(true)}
          >
            <CalculatorIcon />
            {expand && !smallScreens && t('homePage.calculator')}
          </Button>
          {!largeScreens && (
            <Button color={'tertiary'} onClick={handleExpand} sx={expandBtn}>
              {expand ? <MinimizeIcon /> : <ExpandIcon />}
            </Button>
          )}
        </Box>
      </Box>
      <Box>
        {currency?.front.map((item: any, index: number) => (
          <Box sx={currencyBox(expand)} key={index}>
            <Box>
              <img src={item.icon} alt="logo" width="44" height="44" />
            </Box>
            <Box sx={currencyInfoBox}>
              <Typography sx={currencyInfoText}>{t('homePage.buy')}</Typography>
              <Typography sx={currencyText}>{item.buy}</Typography>
            </Box>
            <Box sx={currencyInfoBox}>
              <Typography sx={currencyInfoText}>{t('homePage.sell')}</Typography>
              <Typography sx={currencyText}>{item.sell}</Typography>
            </Box>
            {(expand || largeScreens) && (
              <Box sx={currencyInfoBox}>
                <Typography sx={currencyInfoText}>{t('homePage.cbar')}</Typography>
                <Typography sx={currencyText}>{item.cbar}</Typography>
              </Box>
            )}
          </Box>
        ))}
      </Box>
      <CalculatorModal
        showCalculator={showCalculator}
        setShowCalculator={setShowCalculator}
        date={currency?.date}
        bank={currency?.BANK}
        cbar={currency?.CBAR}
      />
    </>
  );
};

export default CurrencyBox;
